import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Main from "../../Main";
import { url } from "@recoil/Store";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useEffect } from "react";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
export default function NoticeDetailEn() {
    const [urls, setUrl] = useRecoilState(url);
    const [qs] = useSearchParams();
    const postId = qs.get("id");
    return (_jsxs(_Fragment, { children: [_jsx(Main, {}), postId &&
                _jsx(View, { postId: postId, url: urls, setUrl: setUrl })] }));
}
function View(props) {
    const { postId, url, setUrl } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_POST,
        appPath: `/open/board/post/${postId}`,
        appQuery: { passwd: "" },
        userToken: "",
        watch: "",
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItem(data.body);
            }
        }
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "notice-section" }, { children: _jsx("div", Object.assign({ className: "notice-header" }, { children: _jsx("h2", { children: (item) && item.title }) })) })), _jsxs("div", Object.assign({ className: "wrap" }, { children: [_jsx("div", Object.assign({ className: "notice-detail-head" }, { children: _jsxs("div", Object.assign({ className: "notice-detail-info" }, { children: [_jsx("div", { children: _jsx("span", { children: "Notice" }) }), _jsx("div", { children: _jsx("span", { children: (item) && (item.createdAt) ? dayjs(item.createdAt).format("YYYY/MM/DD") : "-" }) })] })) })), (item) && item.attachList.map((files) => (_jsx("div", Object.assign({ className: "notice-detail-file", onClick: (e) => cutil.handleDownload(e, files, files.originalFileName) }, { children: _jsxs("a", Object.assign({ href: "#" }, { children: [files.originalFileName, _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M12 15.577L8.461 12.039L9.169 11.319L11.5 13.65V5H12.5V13.65L14.83 11.32L15.539 12.039L12 15.577ZM6.616 19C6.15533 19 5.771 18.846 5.463 18.538C5.155 18.23 5.00067 17.8453 5 17.384V14.961H6V17.384C6 17.538 6.064 17.6793 6.192 17.808C6.32 17.9367 6.461 18.0007 6.615 18H17.385C17.5383 18 17.6793 17.936 17.808 17.808C17.9367 17.68 18.0007 17.5387 18 17.384V14.961H19V17.384C19 17.8447 18.846 18.229 18.538 18.537C18.23 18.845 17.8453 18.9993 17.384 19H6.616Z", fill: "#0048FF" }) }))] })) })))), _jsx("div", Object.assign({ className: "notice-detail-body" }, { children: (item) && item.content }))] })), _jsx("div", Object.assign({ className: "notice-detail-btn" }, { children: _jsxs("button", Object.assign({ type: "button", onClick: (e) => cutil.handleUrl(e, url.depth1, url.depth2, navigate, setUrl) }, { children: [" ", _jsx("a", Object.assign({ href: "#" }, { children: "List" }))] })) }))] }));
}
